import { useEffect, useState } from "react";
import { BadgeCheck, Loader2, Save, Search } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

const TestBox = () => {
  const [id, setId] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/admin/nickcheck/test", { params: { id } });
      setRes(data);
    } catch (e) {
      toast.error(errMsg(e, "Tes gagal"));
    } finally {
      setBusy(false);
    }
  };
  const label = { valid: `Valid: ${res?.nickname}`, invalid: "ID tidak ditemukan", unavailable: "API tidak merespon / API key salah" }[res?.status];
  return (
    <div className="mt-4 rounded-xl border border-white/5 bg-[#0d0d12] p-3">
      <div className="text-xs uppercase tracking-widest text-zinc-500">Tes cek ID</div>
      <div className="mt-2 flex gap-2">
        <input value={id} onChange={(e) => setId(e.target.value.replace(/\D/g, "").slice(0, 10))} placeholder="ID Royal Dream" className="rk-input !py-2 text-sm" data-testid="nickcheck-test-id" />
        <button type="button" onClick={run} disabled={busy || id.length < 5} className="rk-btn-ghost inline-flex items-center gap-1 text-xs disabled:opacity-50" data-testid="nickcheck-test-btn">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <Search size={13} />} Tes
        </button>
      </div>
      {res ? <p className={`mt-2 text-xs font-bold ${res.status === "valid" ? "text-emerald-400" : "text-rose-400"}`} data-testid="nickcheck-test-result">{label}</p> : null}
    </div>
  );
};

export const NickCheckSettings = ({ canManage }) => {
  const [cfg, setCfg] = useState(null);
  const [key, setKey] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/nickcheck").then(({ data }) => {
      setCfg(data);
      setEnabled(data.enabled);
    }).catch(() => {});
  }, []);
  if (!cfg) return null;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/nickcheck", { enabled, api_key: key });
      setCfg(data);
      setKey("");
      toast.success("Pengaturan cek nickname disimpan");
    } catch (err) {
      toast.error(errMsg(err, "Gagal menyimpan"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={save} className="rk-glass rounded-2xl p-6 lg:col-span-2" data-testid="nickcheck-settings">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="flex items-center gap-2 text-lg font-bold"><BadgeCheck size={18} className="text-[#e5b80b]" /> Cek Nickname Royal Dream</h3>
          <p className="mt-1 text-xs text-zinc-500">Saat member mengisi ID Royal Dream, nickname otomatis muncul dengan centang. ID yang tidak ditemukan tidak bisa lanjut. Jika API sedang error, member tetap bisa lanjut. Penyedia: api-otomatis.my.id</p>
        </div>
        <label className="flex items-center gap-2 text-xs font-bold">
          <span className={enabled ? "text-emerald-400" : "text-zinc-500"} data-testid="nickcheck-status">{enabled ? "ON" : "OFF"}</span>
          <Switch checked={enabled} disabled={!canManage} onCheckedChange={setEnabled} data-testid="nickcheck-enabled-switch" />
        </label>
      </div>
      <label className="mt-4 block max-w-xl">
        <span className="text-xs uppercase tracking-widest text-zinc-500">API Key {cfg.has_key ? <span className="normal-case text-emerald-400" data-testid="nickcheck-key-hint">· tersimpan ({cfg.key_hint})</span> : <span className="normal-case text-rose-400">· belum diisi</span>}</span>
        <input type="password" value={key} onChange={(e) => setKey(e.target.value)} disabled={!canManage} placeholder={cfg.has_key ? "Isi untuk mengganti key" : "Tempel API key dari api-otomatis.my.id"} autoComplete="off" className="rk-input mt-2" data-testid="nickcheck-key-input" />
      </label>
      {canManage ? (
        <button type="submit" disabled={busy || (enabled && !cfg.has_key && !key.trim())} className="rk-btn-primary mt-4 inline-flex items-center gap-2 text-sm disabled:opacity-50" data-testid="nickcheck-save-btn">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Simpan
        </button>
      ) : null}
      {canManage && cfg.has_key ? <TestBox /> : null}
    </form>
  );
};
